import React from 'react';
import { resolvePublicFileUrl } from '../../utils/imageUrls';

type ModThumbProps = {
  url?: string | null;
  alt: string;
  size?: 'sm' | 'md';
  className?: string;
};

/** Compact part photo for list / card / timeline rows. */
export const ModThumb: React.FC<ModThumbProps> = ({
  url,
  alt,
  size = 'sm',
  className = '',
}) => {
  if (!url) return null;
  const src = resolvePublicFileUrl(url) || url;
  const dim = size === 'md' ? 'w-16 h-16 sm:w-20 sm:h-20' : 'w-11 h-11 sm:w-12 sm:h-12';
  return (
    <img
      src={src}
      alt={alt}
      className={`${dim} rounded-lg object-cover border border-white/[0.08] bg-[#0a0a0a] shrink-0 ${className}`}
      loading="lazy"
    />
  );
};

export default ModThumb;
